import { makeStyles } from "@fluentui/react-components";

export const useToasterStyles = makeStyles({
    root: {}
});
